import { NOT_SELECTED_ERROR } from '../../../Stepper/constants'

const validate = ({ activeVehicleId, appointmentDate }, { isTrailer }) => {
  const errors = {}

  if (!(activeVehicleId || isTrailer) || !(appointmentDate && appointmentDate.time)) {
    errors.activeVehicleId = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  } else if (!(appointmentDate && appointmentDate.time)) {
    errors.appointmentDate = NOT_SELECTED_ERROR
    errors._error = NOT_SELECTED_ERROR
  }

  return errors
}

export default validate
